(() => {
  const setButtonState = (sectionId, active) => {
    const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!button || button.hasAttribute('disabled')) return;

    button.classList.toggle('preorder-button', active);
    const label = button.querySelector('span');
    if (label) label.textContent = active ? 'Pre-order' : window.variantStrings?.addToCart || 'Add to cart';
  };

  const applyPreorderState = (sectionId, html) => {
    const sourceDetails = html.getElementById(`PreorderDetails-${sectionId}`);
    const targetDetails = document.getElementById(`PreorderDetails-${sectionId}`);
    if (!sourceDetails || !targetDetails) return;

    targetDetails.innerHTML = sourceDetails.innerHTML;
    targetDetails.dataset.preorderActive = sourceDetails.dataset.preorderActive;
    targetDetails.dataset.preorderLeadTime = sourceDetails.dataset.preorderLeadTime;

    const active = sourceDetails.dataset.preorderActive === 'true';
    const sourceBadge = html.getElementById(`PreorderBadge-${sectionId}`);
    const targetBadge = document.getElementById(`PreorderBadge-${sectionId}`);
    if (sourceBadge && targetBadge) {
      targetBadge.className = sourceBadge.className;
      targetBadge.dataset.preorderActive = sourceBadge.dataset.preorderActive;
    }

    setButtonState(sectionId, active);
  };

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event?.data;
      if (data?.sectionId && data?.html) applyPreorderState(data.sectionId, data.html);
    });
  }
})();
